import { defineStore } from 'pinia';
import { onRequestDefaultError, requests, removeNulls } from '🔗/utils/requests';

const useRolesApi = defineStore('role-api', {
    state: () => ({
    }),
    actions: {
        // Roles
        async list(params = {}) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: '/roles',
                    params,
                    signal: requests.signal('roles')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async addRole(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/roles',
                    data: removeNulls(data),
                    // signal: requests.signal('role-add')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                } else {
                    onRequestDefaultError({ response: result });
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        }
        // async getRole(id) {
        //     try {
        //         const result = await this.$http({
        //             method: 'GET',
        //             url: `/dict/roles/${ id }`,
        //             params,
        //             signal: requests.signal('role-get', id)
        //         });

        //         if (result.status === 200) {
        //             const { data } = result;

        //             return data;
        //         }
        //     } catch (e) {
        //         onRequestDefaultError(e);
        //     }
        // },
        // async updateRole(id, data) {
        //     try {
        //         const result = await this.$http({
        //             method: 'POST',
        //             url: `/dict/roles/${ id }`,
        //             data,
        //             signal: requests.signal('role-update', id)
        //         });

        //         if (result.status === 200) {
        //             const { data } = result;

        //             return data;
        //         } else {
        //             onRequestDefaultError({ response: result });
        //         }
        //     } catch (e) {
        //         onRequestDefaultError(e);
        //     }
        // },
        // async removeRole(id) {
        //     try {
        //         const result = await this.$http({
        //             method: 'DELETE',
        //             url: `/dict/roles/${ id }`,
        //             signal: requests.signal('role-remove', id)
        //         });

        //         if (result.status === 200) {
        //             const { data } = result;

        //             return data;
        //         } else {
        //             onRequestDefaultError({ response: result });
        //         }
        //     } catch (e) {
        //         onRequestDefaultError(e);
        //     }
        // },
    }
});

export default useRolesApi;
